import { render, staticRenderFns } from "./UnpaidBlock.vue?vue&type=template&id=555083b0&scoped=true"
import script from "./UnpaidBlock.vue?vue&type=script&lang=js"
export * from "./UnpaidBlock.vue?vue&type=script&lang=js"
import style0 from "./UnpaidBlock.vue?vue&type=style&index=0&id=555083b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555083b0",
  null
  
)

export default component.exports